import React from "react";
import {observer} from "mobx-react";
import {VideoSlideBox} from "./boxes/video-slide.box";

interface VideoSlideComponentProps {
    url: string;
}

export const VideoSlideComponent: React.FC<VideoSlideComponentProps> = observer((props) => {

    return <VideoSlideBox>
        {`Video ` + props.url}
    </VideoSlideBox>
})